var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavIconService2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 42,
    viewBox: "0 0 37 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162875",
    "data-name": "\\uADF8\\uB8F9 162875",
    transform: "translate(-730.474 -213.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_321",
    "data-name": "\\uD0C0\\uC6D0 321",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(730.474 255.5) rotate(-90)",
    fill: "#01bf6e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_322",
    "data-name": "\\uD0C0\\uC6D0 322",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(742.474 255.5) rotate(-90)",
    fill: "#01bf6e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_326",
    "data-name": "\\uD0C0\\uC6D0 326",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(742.474 242.5) rotate(-90)",
    fill: "#01bf6e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_323",
    "data-name": "\\uD0C0\\uC6D0 323",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(753.474 255.5) rotate(-90)",
    fill: "#01bf6e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_327",
    "data-name": "\\uD0C0\\uC6D0 327",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(753.474 242.5) rotate(-90)",
    fill: "#01bf6e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_331",
    "data-name": "\\uD0C0\\uC6D0 331",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(753.474 229.5) rotate(-90)",
    fill: "#01bf6e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_324",
    "data-name": "\\uD0C0\\uC6D0 324",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(764.474 255.5) rotate(-90)",
    fill: "#01bf6e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_328",
    "data-name": "\\uD0C0\\uC6D0 328",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(764.474 242.5) rotate(-90)",
    fill: "#01bf6e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_332",
    "data-name": "\\uD0C0\\uC6D0 332",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(764.474 229.5) rotate(-90)",
    fill: "#01bf6e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_336",
    "data-name": "\\uD0C0\\uC6D0 336",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(764.474 216.5) rotate(-90)",
    fill: "#01bf6e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIconService2);
export default __webpack_public_path__ + "static/media/navIconService2.18e58d6a8d840bf6f6ec5ee3d0dda9dc.svg";
export { ForwardRef as ReactComponent };